import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Button,
  Box,
  useTheme,
  useMediaQuery,
  Chip,
  Tooltip,
  Avatar,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import MenuIcon from "@mui/icons-material/Menu";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import LogoutIcon from "@mui/icons-material/Logout";
import CloudDoneIcon from "@mui/icons-material/CloudDone";
import CloudOffIcon from "@mui/icons-material/CloudOff";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
//import { NavLink, useNavigate } from "react-router-dom";

import HistoryDropdown from "./HistoryDropdown";
import AttendanceDropdown from "./AttendanceDropdown";
import SettingsDropdown from "./SettingsDropdown";

import { NavLink, useNavigate, useLocation } from "react-router-dom";

// show AttendanceDropdown only for HR (Admin)
import { allowedUsers } from "../components/constants";

/* Reusable nav button */
const NavButton = ({ to, startIcon, children }) => (
  <Button
    component={NavLink}
    to={to}
    startIcon={startIcon}
    sx={{
      color: "#1e1e1e",
      borderRadius: 2,
      textTransform: "none",
      fontWeight: 600,
      px: 1.25,
      fontSize: 14,
      "&.active": {
        bgcolor: "rgba(0,150,136,0.12)",
        color: "#00695c",
      },
      "&:hover": {
        bgcolor: "rgba(0,0,0,0.06)",
      },
    }}
  >
    {children}
  </Button>
);

const HeaderAppBar = ({ fullName, handleLogout, toggleDrawer }) => {

  const location = useLocation();
  const isHRPage = location.pathname.includes("/calendar/new")|| location.pathname.includes("/settings/leaveroles");
  const isCalendarNew = location.pathname.includes("/calendar/new");
  const isApprove= location.pathname.includes("/calendar/approve");
  const isLeaveRoles= location.pathname.includes("/settings/leaveroles");
  const isVisitReport=location.pathname.includes("calendar/visit-report");
  const isOtherRoles= location.pathname.includes("/settings/notificationroles");
  const isVisitRoles= location.pathname.includes("/settings/visitroles");
  const isMyAttendance=location.pathname.includes("/calendar");
  const isVisitHistory=location.pathname.includes("/calendar/visits");
  const isMyAttendanceOnly =
  location.pathname === "/home/calendar" || location.pathname === "/home/calendar/";
  const isLeaveRequestHistory = location.pathname.includes("/calendar/leaveRequest");
  const isAllEmployeesActions = location.pathname.includes("/calendar/EmployeesActions");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  const [online, setOnline] = useState(
    typeof navigator !== "undefined" ? navigator.onLine : true
  );

  // show AttendanceDropdown only for HR (Admin)
const callerUid = localStorage.getItem("saved_username") || "";
const isAdmin = allowedUsers.includes(callerUid);

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  return (
    <AppBar
      position="sticky"
      className="no-print"
      elevation={0}
      sx={{
        bgcolor: "#ffffff",
        color: "#1e1e1e",
        borderBottom: "1px solid rgba(0,0,0,0.08)",
        boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          minHeight: 70,
          gap: 1,
          px: { xs: 1.5, sm: 3 },
        }}
      >
        
        {/* Left */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          {/* Back Button */}
          {!isCalendarNew && (
          <Tooltip title="Go back">
            <IconButton
              onClick={() => {
                if (window.history.length > 1) {
                  navigate(-1);
                } else {
                  navigate("/home");
                }
              }}
              sx={{
                bgcolor: "rgba(0,0,0,0.06)",
                borderRadius: 2,
                "&:hover": {
                  bgcolor: "rgba(0,0,0,0.12)",
                },
              }}
            >
              <ArrowBackIcon />
            </IconButton>
          </Tooltip>
          )}
        
          {/* Hide avatar, name, online chip on HR calendar page */}
          {!isHRPage && !isApprove && !isVisitRoles && !isVisitReport && !isOtherRoles && (
            <>
          {/* Home Avatar */}
          <Avatar
            sx={{
              bgcolor: "#009688",
              color: "#fff",
              width: 38,
              height: 38,
              boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
            }}
          >
            <HomeIcon fontSize="small" />
          </Avatar>

          {/* Title */}
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 800,
                letterSpacing: 0.4,
                maxWidth: { xs: 160, sm: 260 },
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              title={fullName}
            >
              {fullName || "Welcome"}
            </Typography>
            <Typography
              variant="caption"
              sx={{ color: "rgba(0,0,0,0.6)" }}
            >
              Bee Attendance • Dashboard
            </Typography>
          </Box>

          {/* Online Status */}
          <Chip
            size="small"
            icon={online ? <CloudDoneIcon /> : <CloudOffIcon />}
            label={online ? "Online" : "Offline"}
            color={online ? "success" : "warning"}
            sx={{
              ml: 1,
              fontWeight: 700,
              bgcolor: online
                ? "rgba(200,230,201,0.35)"
                : "rgba(255,224,178,0.35)",
              "& .MuiChip-label": { px: 0.75 },
              display: { xs: "none", md: "inline-flex" },
            }}
          />
          </>
  )}
        </Box>

        {/* Right */}
        {isMobile ? (
          <Tooltip title="Open menu">
            <IconButton
              onClick={toggleDrawer}
              sx={{
                bgcolor: "rgba(0,0,0,0.06)",
                borderRadius: 2,
                "&:hover": {
                  bgcolor: "rgba(0,0,0,0.12)",
                },
              }}
            >
              <MenuIcon />
            </IconButton>
          </Tooltip>
        ) : (
          // <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
          //   {false && (
          //     <NavButton to="/home/" startIcon={<FingerprintIcon />}>
          //       Finger Print
          //     </NavButton>
          //   )}

          //   <AttendanceDropdown />

          //   {false && (
          //     <>
          //       <HistoryDropdown />
          //     </>
          //   )}

          //   <SettingsDropdown />

          //   <Tooltip title="Logout">
          //     <Button
          //       onClick={handleLogout}
          //       startIcon={<LogoutIcon />}
          //       sx={{
          //         color: "#1e1e1e",
          //         borderRadius: 2,
          //         textTransform: "none",
          //         fontWeight: 700,
          //         px: 1.5,
          //         bgcolor: "rgba(0,0,0,0.05)",
          //         "&:hover": {
          //           bgcolor: "rgba(0,0,0,0.1)",
          //         },
          //         boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
          //       }}
          //     >
          //       Logout
          //     </Button>
          //   </Tooltip>
          // </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
            {/* {!isHRPage && <AttendanceDropdown />} */}
            {/* { isAdmin && <AttendanceDropdown />} */}
            {!isAllEmployeesActions && !isLeaveRequestHistory && <AttendanceDropdown />}

           {/* {!isLeaveRoles && !isVisitRoles && !isApprove && !isVisitHistory && !isMyAttendanceOnly && isAdmin && <SettingsDropdown />} */}
           { !isApprove && !isVisitHistory && !isMyAttendanceOnly && !isLeaveRequestHistory && !isVisitReport && !isAllEmployeesActions && <SettingsDropdown />}

            {!isHRPage && !isApprove && !isVisitHistory&& !isVisitRoles&& !isLeaveRequestHistory && !isAllEmployeesActions && !isVisitReport && !isOtherRoles && (
              <Tooltip title="Logout">
                <Button
                  onClick={handleLogout}
                  startIcon={<LogoutIcon />}
                  sx={{
                    color: "#1e1e1e",
                    borderRadius: 2,
                    textTransform: "none",
                    fontWeight: 700,
                    px: 1.5,
                    bgcolor: "rgba(0,0,0,0.05)",
                    "&:hover": { bgcolor: "rgba(0,0,0,0.1)" },
                    boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
                  }}
                >
                  Logout
                </Button>
              </Tooltip>
            )}
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default HeaderAppBar;